var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 53 53",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5e5eef",
    d: "M50.5 17.368v21.023a4.425 4.425 0 0 1-4.425 4.425H25.928l-8.056 5.972a.723.723 0 0 1-1.154-.581v-5.391h-2.2a4.425 4.425 0 0 1-4.425-4.425V17.368c0-2.444 1.98-4.425 5.647-4.425h31.558c1.22 0 3.202 1.981 3.202 4.425z",
    opacity: 1,
    "data-original": "#5e5eef",
    className: "hovered-path"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M33.079 15.868h-.766a.798.798 0 0 1 0-1.595h.766a.798.798 0 0 1 0 1.595zM43.73 15.868h-7.28a.798.798 0 0 1 0-1.595h7.28a.798.798 0 0 1 0 1.595z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12.275 35.66a.798.798 0 0 1-.797-.797v-4.897a.798.798 0 0 1 1.595 0v4.897c0 .44-.357.797-.798.797zM12.275 27.623a.798.798 0 0 1-.797-.798v-.83a.798.798 0 0 1 1.595 0v.83c0 .44-.357.798-.798.798z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4242e5",
    d: "M50.5 17.367v21.025a4.424 4.424 0 0 1-4.424 4.424H25.928l-8.05 5.977a.729.729 0 0 1-1.16-.585V46.76l7.015-5.205c.237-.176.525-.271.82-.271h19.694a4.424 4.424 0 0 0 4.424-4.424V15.836c0-.925-.287-1.787-.776-2.5a4.406 4.406 0 0 1 2.605 4.031z",
    opacity: 1,
    "data-original": "#4242e5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M14.346 35.879V19.88c0-1.481 1.201-2.683 3.906-2.683h25.534c1.207.038 2.46 1.202 2.46 2.683V35.88a2.683 2.683 0 0 1-2.682 2.683H17.029a2.683 2.683 0 0 1-2.683-2.683z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e4e3ff",
    d: "M46.246 19.883v15.994a2.676 2.676 0 0 1-2.68 2.68h-26.54a2.681 2.681 0 0 1-2.563-1.872c.16.032.33.043.5.043h26.53a2.685 2.685 0 0 0 2.68-2.69V18.042c0-.277-.043-.553-.118-.808a2.695 2.695 0 0 1 2.191 2.648z",
    opacity: 1,
    "data-original": "#e4e3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5bc658",
    d: "M37.187 27.104c0 3.801-3.084 6.885-6.896 6.885a6.887 6.887 0 0 1-6.885-6.885 6.891 6.891 0 1 1 13.78 0z",
    opacity: 1,
    "data-original": "#5bc658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.2 27.343h-.016a.427.427 0 0 1-.412-.443 5.512 5.512 0 0 1 2.26-4.27.429.429 0 0 1 .506.69 4.664 4.664 0 0 0-1.91 3.61.428.428 0 0 1-.428.413zM28.796 22.196a.43.43 0 0 1 .331-.507 5.623 5.623 0 0 1 1.033-.12c.228.047.432.18.438.416a.427.427 0 0 1-.416.438 4.908 4.908 0 0 0-.878.104.43.43 0 0 1-.508-.33z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49a247",
    d: "M37.187 27.104c0 3.801-3.084 6.885-6.896 6.885a6.892 6.892 0 0 1-5.61-2.902 6.87 6.87 0 0 0 4.255 1.48c3.813 0 6.897-3.084 6.897-6.885 0-1.49-.478-2.868-1.275-3.994a6.873 6.873 0 0 1 2.629 5.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.099 28.051-3.019 2.127a1.165 1.165 0 0 1-1.836-.952v-4.254a1.165 1.165 0 0 1 1.836-.952l3.019 2.127c.658.464.658 1.44 0 1.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e4e3ff",
    d: "m33.092 28.048-3.004 2.13a1.176 1.176 0 0 1-1.834-.751c.367.192.821.21 1.205-.07l3.021-2.13c.402-.28.56-.751.472-1.17l.14.087c.663.472.663 1.45 0 1.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474646",
    d: "m23.869 5.346 2.801 6.617a2.027 2.027 0 0 1-.612 2.383c-1.628 1.295-4.105 3.716-5.318 5.49a2.493 2.493 0 0 1-2.466 1.043c-2.115-.365-5.571-.273-7.63-.007a2.028 2.028 0 0 1-2.138-1.219l-2.801-6.617z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2c2c",
    d: "m23.869 5.35 2.798 6.611a2.02 2.02 0 0 1-.607 2.38c-1.625 1.299-4.108 3.724-5.317 5.494a2.52 2.52 0 0 1-2.47 1.046c-2.112-.365-5.57-.274-7.634-.011a2.052 2.052 0 0 1-1.471-.381c.253.058.53.08.81.05 2.058-.273 5.522-.353 7.634.011a2.57 2.57 0 0 0 2.47-1.045c1.208-1.77 3.687-4.206 5.317-5.494a2.02 2.02 0 0 0 .607-2.38l-2.58-6.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2c2c",
    d: "m24.775 7.483.28.662-7.782 5.947a1.447 1.447 0 0 1-.698.296l-9.682 1.446-.28-.662 9.682-1.446c.252-.04.495-.142.698-.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.595 19.831a.421.421 0 0 1-.552-.223l-.367-.866a.421.421 0 0 1 .776-.328l.366.865a.421.421 0 0 1-.223.552zM9.687 17.686a.421.421 0 0 1-.552-.223l-.133-.313a.421.421 0 0 1 .776-.328l.132.312a.421.421 0 0 1-.223.552z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b1b",
    d: "m27.353 4.302.296.7-.006.002a.351.351 0 0 1-.128.398l-10.518 8.04c-.199.156-.443.26-.7.296l-13.08 1.95a.373.373 0 0 1-.403-.213l-.005-.013-.276-.652a.37.37 0 0 0 .405.22l13.08-1.95c.254-.044.499-.147.7-.296l10.518-8.04c.15-.12.178-.3.117-.442z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474646",
    d: "M27.236 4.744 16.719 12.78a1.526 1.526 0 0 1-.7.297L2.934 15.032c-.386.058-.596-.437-.285-.674l10.51-8.032c.205-.156.446-.259.701-.297L26.95 4.07c.386-.058.596.437.286.674z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9b938",
    d: "M4.35 19.745 2.613 15.64c-.29-.686.031-1.48.717-1.772l11.635-4.926a.25.25 0 0 1 .195.46L3.526 14.33a.851.851 0 0 0-.451 1.115L4.81 19.55a.25.25 0 0 1-.46.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9b938",
    d: "m5.254 24.198 2.001-.847a.423.423 0 0 0 .172-.646l-1.62-2.113a1.011 1.011 0 0 0-.046-.67 1.052 1.052 0 0 0-1.377-.558 1.051 1.051 0 0 0-.552 1.375c.092.217.252.393.449.499l.39 2.634c.042.274.33.434.583.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ecb021",
    d: "m5.254 24.198.408-.173a.423.423 0 0 1-.583-.326l-.349-2.357a.625.625 0 0 0-.206-.39 1.048 1.048 0 0 1 .078-1.65.747.747 0 0 0-.218.062 1.051 1.051 0 0 0-.552 1.375c.092.217.252.393.449.499l.39 2.634c.042.274.33.434.583.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9b938",
    d: "M16.462 8.626c.164.388-.437 1.012-1.332 1.39-.906.384-1.771.382-1.936-.007-.164-.388.437-1.011 1.342-1.395.896-.379 1.761-.376 1.926.012z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.c1e13efc3f8add4a4b285e7902ddbf93.svg";
export { ForwardRef as ReactComponent };